<template>
  <v-container fluid class="admin-coupon">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="ml-2"
               @click="create">
          {{ $t('admin_acc_coupon_group.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminCouponGroupList full-height
                          :refresh-trigger.sync="bookingRefreshTrigger"></AdminCouponGroupList>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AdminCouponGroupList from "@/components/acc_booking/coupon/AdminCouponGroupList.vue";
import AddCouponGroupModal from "@/components/acc_booking/coupon/AddCouponGroupModal.vue";
import EditCouponGroupModal from "@/components/acc_booking/coupon/EditCouponGroupModal.vue";

export default {
  name: 'CouponGroup',
  components: {AdminCouponGroupList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refresh = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const create = async function () {
      const groupId = await root.$dialog.showAndWait(AddCouponGroupModal, {
        showClose: false,
        persistent: true,
        width: '60vw',
      });

      if (groupId) {
        refresh();
        await root.$dialog.showAndWait(EditCouponGroupModal, {
          couponGroupId: groupId,
          persistent: true,
          width: '80vw',
        });
      }
    }
    return {
      bookingRefreshTrigger,
      refresh,

      create,
    }
  }
}
</script>

<style lang="less">
.admin-coupon {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

